import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { PoAttentionFlag } from './poStatus';

export function PoAttentionNotices({ flags }: { flags: PoAttentionFlag[] }) {
    if (flags.length === 0) return null;
    return (
        <div className="flex flex-col gap-2">
            {flags.map((flag) => (
                <div
                    key={flag.key}
                    className={`flex items-start gap-2.5 p-3 rounded-lg border ${
                        flag.tone === 'danger'
                            ? 'border-red-300 bg-red-50 text-red-900'
                            : 'border-amber-300 bg-amber-50 text-amber-900'
                    }`}
                >
                    <ExclamationTriangleIcon
                        className={`h-4 w-4 shrink-0 mt-0.5 ${
                            flag.tone === 'danger' ? 'text-red-700' : 'text-amber-700'
                        }`}
                    />
                    <div className="min-w-0">
                        <p className="text-sm font-semibold">{flag.label}</p>
                        <p className="text-xs mt-0.5">{flag.detail}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}
